"use strict";

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/slicedToArray");

var _construct = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validations_1 = require("../../utils/validations");

var MessageRef_1 = __importDefault(require("./MessageRef"));

var StreamID_1 = require("../../../src/utils/StreamID");

var StreamPartID_1 = require("../../utils/StreamPartID");

var MessageID = /*#__PURE__*/function () {
  function MessageID(streamId, streamPartition, timestamp, sequenceNumber, publisherId, msgChainId) {
    _classCallCheck(this, MessageID);

    (0, validations_1.validateIsNotEmptyString)('streamId', streamId);
    (0, validations_1.validateIsNotNegativeInteger)('streamPartition', streamPartition);
    (0, validations_1.validateIsNotNegativeInteger)('timestamp', timestamp);
    (0, validations_1.validateIsNotNegativeInteger)('sequenceNumber', sequenceNumber);
    (0, validations_1.validateIsString)('publisherId', publisherId);
    (0, validations_1.validateIsString)('msgChainId', msgChainId);
    this.streamId = streamId;
    this.streamPartition = streamPartition;
    this.timestamp = timestamp;
    this.sequenceNumber = sequenceNumber;
    this.publisherId = publisherId;
    this.msgChainId = msgChainId;
  }

  _createClass(MessageID, [{
    key: "toArray",
    value: function toArray() {
      return [this.streamId, this.streamPartition, this.timestamp, this.sequenceNumber, this.publisherId, this.msgChainId];
    }
  }, {
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return (0, StreamPartID_1.toStreamPartID)(this.streamId, this.streamPartition);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return JSON.stringify(this.toArray());
    }
  }, {
    key: "toMessageRef",
    value: function toMessageRef() {
      return new MessageRef_1.default(this.timestamp, this.sequenceNumber);
    }
  }, {
    key: "clone",
    value: function clone() {
      return _construct(MessageID, _toConsumableArray(this.toArray()));
    }
  }], [{
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr = _slicedToArray(arr, 6),
          streamId = _arr[0],
          streamPartition = _arr[1],
          timestamp = _arr[2],
          sequenceNumber = _arr[3],
          publisherId = _arr[4],
          msgChainId = _arr[5];

      return new MessageID((0, StreamID_1.toStreamID)(streamId), streamPartition, timestamp, sequenceNumber, publisherId, msgChainId);
    }
  }]);

  return MessageID;
}();

exports.default = MessageID;